/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@mui/material";
import { TextFieldWithHelperText } from "../../../../components/TextFieldWithHelperText";
import { submitRequestDialogStyles as styles } from "../../styles";
import { HighlightOffRounded, UploadFile } from "@mui/icons-material";

const ScriptItem = ({
  listAllCommonScriptsResp,
  scriptDetails,
  setScriptDetails,
  deleteScript,
}) => {
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileContent = await file.text();
    setScriptDetails({
      ...scriptDetails,
      scriptName: file.name,
      scriptContent: fileContent,
    });
  };

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <FormControlLabel
            control={
              <Switch
                color="secondary"
                checked={scriptDetails?.customScript || false}
                onChange={() =>
                  setScriptDetails({
                    customScript: !scriptDetails?.customScript,
                    cloud: "ALL",
                    rebootTime: 0,
                    scriptName: "",
                  })
                }
              />
            }
            label={"custom script"}
          />
        </Grid>

        <Grid item xs={3}>
          {scriptDetails?.customScript ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                mb: "0px",
                pb: "0px",
                mt: "auto",
              }}
            >
              <input
                accept=".sh"
                type="file"
                id="upload-script"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="upload-script">
                <IconButton component="span" color="secondary">
                  <UploadFile />
                </IconButton>
              </label>
              <Typography variant="h6" sx={{ mt: 1 }}>
                {scriptDetails?.scriptName
                  ? scriptDetails.scriptName
                  : "No file selelected !"}
              </Typography>
            </Box>
          ) : (
            <FormControl sx={styles.formControl}>
              <InputLabel size="string" color="secondary">
                Script name
              </InputLabel>
              <Select
                fullWidth
                label={"Script"}
                color="secondary"
                value={scriptDetails?.scriptName}
                onChange={(e) =>
                  setScriptDetails({
                    ...scriptDetails,
                    scriptName: e.target.value,
                  })
                }
              >
                {listAllCommonScriptsResp?.scripts?.map((script) => (
                  <MenuItem value={script}>{script}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid item xs={2}>
          <FormControl sx={styles.formControl}>
            <InputLabel size="string" color="secondary">
              Cloud
            </InputLabel>
            <Select
              fullWidth
              label={"cloud"}
              color="secondary"
              value={scriptDetails?.cloud}
              onChange={(e) => {
                setScriptDetails({
                  ...scriptDetails,
                  cloud: e.target.value,
                });
              }}
            >
              {["ALL", "AWS", "AZURE"].map((cloud, i) => (
                <MenuItem value={cloud} key={i}>
                  {cloud}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextFieldWithHelperText
            label="reboot time (minutes)"
            fullWidth={true}
            color="secondary"
            helperText="Set 0 to disable reboot"
            value={scriptDetails?.rebootTime}
            onChange={(e) => {
              const val = Number(e.target.value);
              if (isNaN(val)) return;
              if (val < 0) return;
              setScriptDetails({
                ...scriptDetails,
                rebootTime: val,
              });
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <IconButton size="large" onClick={() => deleteScript()}>
            <HighlightOffRounded />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ScriptItem;
